"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useScrollDown;

var _react = require("react");

var _useScrollRelative = _interopRequireDefault(require("./internal/useScrollRelative"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useScrollDown() {
  var scrollRelative = (0, _useScrollRelative.default)();
  return (0, _react.useCallback)(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return scrollRelative.apply(void 0, ['down'].concat(args));
  }, [scrollRelative]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTY3JvbGxEb3duIiwic2Nyb2xsUmVsYXRpdmUiLCJ1c2VTY3JvbGxSZWxhdGl2ZSIsInVzZUNhbGxiYWNrIiwiYXJncyJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZVNjcm9sbERvd24udHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ2FsbGJhY2sgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB1c2VTY3JvbGxSZWxhdGl2ZSBmcm9tICcuL2ludGVybmFsL3VzZVNjcm9sbFJlbGF0aXZlJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlU2Nyb2xsRG93bigpOiAob3B0aW9ucz86IHsgZGlzcGxhY2VtZW50OiBudW1iZXIgfSkgPT4gdm9pZCB7XG4gIGNvbnN0IHNjcm9sbFJlbGF0aXZlID0gdXNlU2Nyb2xsUmVsYXRpdmUoKTtcblxuICByZXR1cm4gdXNlQ2FsbGJhY2soKC4uLmFyZ3MpID0+IHNjcm9sbFJlbGF0aXZlKCdkb3duJywgLi4uYXJncyksIFtzY3JvbGxSZWxhdGl2ZV0pO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRUE7Ozs7QUFFZSxTQUFTQSxhQUFULEdBQXVFO0VBQ3BGLElBQU1DLGNBQWMsR0FBRyxJQUFBQywwQkFBQSxHQUF2QjtFQUVBLE9BQU8sSUFBQUMsa0JBQUEsRUFBWTtJQUFBLGtDQUFJQyxJQUFKO01BQUlBLElBQUo7SUFBQTs7SUFBQSxPQUFhSCxjQUFjLE1BQWQsVUFBZSxNQUFmLFNBQTBCRyxJQUExQixFQUFiO0VBQUEsQ0FBWixFQUEwRCxDQUFDSCxjQUFELENBQTFELENBQVA7QUFDRCJ9